import { useTranslation } from 'react-i18next';
import FeedbackBoard from '@/components/feedback/FeedbackBoard';

/** Портал: мои замечания (ссылка из виджета и уведомлений; в навигации не показывается). */
export default function PortalFeedbackPage() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="mb-4 border-b border-background-200 pb-4">
        <h1 className="text-[20px] font-semibold leading-6 text-foreground-950">{t('fb.myTitle')}</h1>
        <p className="mt-1 max-w-3xl text-[12.5px] leading-5 text-foreground-500">{t('fb.mySubtitle')}</p>
      </div>
      <FeedbackBoard />
    </div>
  );
}
